module.exports = __webpack_public_path__ + "img/zendesk-logo.81c34f56.svg";